export const FORM_QUESTIONS = [
  { key: "prenom", n: 1, type: "text", label: "Quel est votre prénom ?", placeholder: "Votre prénom" },
  {
    key: "__contact",
    n: 2,
    type: "group",
    label: "Quelle est votre adresse e-mail et votre numéro pour que nous puissions vous recontacter ?",
    fields: [
      { key: "email", type: "email", label: "Votre adresse e-mail", placeholder: "vous@exemple.com" },
      { key: "telephone", type: "tel", label: "Votre numéro de téléphone", placeholder: "06 12 34 56 78" },
    ],
  },
  {
    key: "pratique_chretienne",
    n: 3,
    type: "radio",
    label: "Avez-vous déjà pratiqué la musique dans un contexte chrétien ?",
    options: [
      "Oui, j'ai joué ou chanté dans une église",
      "Oui, mais uniquement en loisir",
      "Non, je débute totalement",
    ],
  },
  {
    key: "pourquoi_former",
    n: 4,
    type: "textarea",
    label: "Pourquoi souhaitez-vous vous former en musique chrétienne ?",
    placeholder: "Dites-nous pourquoi vous souhaitez vous former",
  },
  {
    key: "objectif_principal",
    n: 5,
    type: "radio",
    label: "Quel est votre objectif principal avec la musique chrétienne ?",
    options: [
      "Mieux servir dans mon église",
      "Développer mes compétences personnelles",
      "Composer et enregistrer mes chants",
      "Enseigner ou accompagner d'autres plus tard",
    ],
  },
  {
    key: "motivation",
    n: 6,
    type: "textarea",
    label: "Qu'est-ce qui montre aujourd'hui que vous êtes vraiment motivé(e) ?",
    placeholder: "Dites-nous en plus sur vos motivations",
  },
  {
    key: "temps_par_semaine",
    n: 7,
    type: "radio",
    label: "Combien de temps pouvez-vous réellement y consacrer chaque semaine ?",
    options: ["Moins d'1h", "1 à 2h", "3 à 5h", "plus de 5h"],
  },
  {
    key: "description",
    n: 8,
    type: "radio",
    label: "Vous vous décrivez comme ?",
    options: ["Chantre", "Musicien", "Aspirant chantre", "Aspirant musicien", "Aucun de ces qualificatifs"],
  },
  {
    key: "situation_pro",
    n: 9,
    type: "text",
    label: "Quelle est votre situation professionnelle ?",
    placeholder: "Votre situation professionnelle",
  },
  {
    key: "pret_investir",
    n: 10,
    type: "radio",
    label: "Si on avait une solution idéale pour vous aider, seriez-vous prêt(e) à investir pour y accéder ?",
    options: ["Oui", "NON"],
  },
  {
    key: "budget_mensuel",
    n: 11,
    type: "radio",
    label:
      "Si votre candidature est acceptée, quel budget MENSUEL seriez-vous prêt(e) à investir pour échelonner un programme de 6 à 8 mois qui fait sens pour vous ?",
    options: [
      "185 - 220 € PAR MOIS durant 5 mois",
      "de 220 à 370€ PAR MOIS durant 3 ou 4 mois",
      "Pas les moyens pour l'instant",
    ],
  },
  {
    key: "date_demarrage",
    n: 12,
    type: "radio",
    label: "Si vous êtes reçu(e) et éligible à une formation du CMC, quand seriez-vous prêt(e) à démarrer ?",
    options: ["en septembre", "en octobre"],
  },
  {
    key: "decision",
    n: 13,
    type: "textarea",
    label:
      "Vous décidez seul(e) et engagez vos fonds personnels, ou vous devez en discuter avec votre conjoint(e) / famille ?",
    placeholder: "Dites-nous si vous décidez seul(e) ou avez besoin d'en discuter",
  },
  {
    key: "autres_structures",
    n: 14,
    type: "radio",
    label: "Avez-vous pris contact ces derniers temps avec d'autres structures d'enseignement de la musique ?",
    options: ["Oui", "NON"],
  },
  {
    key: "domaines",
    n: 15,
    type: "checkbox",
    label: "Pour quel(s) domaine(s) seriez-vous intéressé(e) ?",
    options: ["Chant", "Piano", "Guitare", "Batterie", "Saxophone", "Violon", "Contre-basse"],
  },
];
